// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2Nrvr","list":"BalanceDue_list__1uQHV","listRow":"BalanceDue_listRow__13cEy","total":"BalanceDue_total__3r0uy"};